import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { User } from '../api/authApi'

export interface AuthState {
  user: User | null
  credentials: {
    AccessToken: string | null
  } | null
  isAuthenticated: boolean
}

const initialState: AuthState = {
  user: null,
  credentials: null,
  isAuthenticated: false,
}

const authSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    setCredentials: (
      state,
      action: PayloadAction<{ user: User; token: string }>,
    ) => {
      state.user = action.payload.user
      state.credentials = {
        AccessToken: action.payload.token,
      }
      state.isAuthenticated = true
    },
    clearCredentials: (state) => {
      state.user = null
      state.credentials = null
      state.isAuthenticated = false
    },
  },
})

export const { setCredentials, clearCredentials } = authSlice.actions
export default authSlice.reducer
